import styled from '@emotion/styled';
import { casinoColors } from 'src/assets/colors';
import { CheckIcon } from 'src/assets/icons/CheckIcon';
import { easeTransform } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';


export const buildCheckboxType = (isChecked: boolean | undefined): string => {
    if (isChecked === true) {
        return `
            background: ${casinoColors.bgColorCategoryHeaderControls};
        `;
    }
    return `
        border: solid 2px ${casinoColors.bgColorCategoryHeaderControls};
        background: none;
    `;
};

interface CheckboxPropsType {
    isDisabled: boolean,
    isChecked: boolean
}

export const CheckboxWrapper = styled('span', { label: 'CheckboxWrapper' })<CheckboxPropsType>`
    align-items: center;
    border-radius: 4px;
    display: flex;
    opacity: ${({isDisabled}): string => isDisabled ? '.2' : '1'};
    flex: 0 0 16px;
    height: 16px;
    justify-content: center;
    position: relative;
    transition: background-color .2s ease;
    width: 16px;
    ${({isChecked}): string => buildCheckboxType(isChecked)};
`;

export const CheckboxContainer = styled('div', { label: 'CheckboxContainer' })`
    align-items: center;
    cursor: pointer;
    display: flex;
    position: relative;
`;

interface PropsType {
    isChecked: boolean
}

export const CheckIconWrapper = styled(CheckIcon, { label: 'CheckIconWrapper' })<PropsType>`
    fill: ${casinoColors.iconColorCheckbox};
    position: absolute;
    transform: ${({isChecked}): string => isChecked ? 'scale(1)' : 'scale(0)'};
    transition: ${easeTransform};
    width: 10px;
`;

